import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getCampList, addCamp, changeTermStatus } from '@/api/course';
import { mixin_export } from '@/utils/exportFile';
let Login = class Login extends Vue {
    constructor() {
        super(...arguments);
        this.search = {
            title: '',
            status: '',
            dateTime: []
        };
        this.tableData = [];
        this.pageNo = 1;
        this.pageSize = 15;
        this.total = 0;
    }
    created() {
        this.getList();
    }
    onSearch() {
        this.pageNo = 1;
        this.getList();
    }
    async getList() {
        let [startTime = '', endTime = ''] = this.search.dateTime || [];
        let data = {
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            title: this.search.title,
            status: this.search.status,
            startTime,
            endTime,
        };
        try {
            const res = await getCampList(data);
            if (res.data.status !== 200)
                return this.$message.error(res.data.msg);
            this.tableData = res.data.data.list;
            this.pageNo = Number(res.data.data.pageNum);
            this.total = Number(res.data.data.total);
        }
        catch (error) {
        }
    }
    changePage(pageNo) {
        this.pageNo = pageNo;
        this.getList();
    }
    changePageSize(pageSize) {
        this.pageSize = pageSize;
        this.getList();
    }
    onAdd(props) {
        this.$prompt('训练营名称', `${props ? '编辑训练营名称' : '添加训练营'}`, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^.{1,19}$/,
            inputErrorMessage: '字数在20字以内',
            inputPlaceholder: '请输入训练营名称（建议字数20字以内）',
            inputValue: props ? props.title : '',
            closeOnClickModal: false,
        }).then(async ({ value }) => {
            let data = {
                title: value
            };
            if (props)
                data.id = props.id;
            try {
                const res = await addCamp(data);
                if (res.data.status !== 200)
                    return this.$message.error(res.data.msg);
                this.$message({
                    type: 'success',
                    message: `${props ? '编辑成功' : '新增成功'}`
                });
                this.getList();
            }
            catch (error) {
            }
        }).catch(() => {
        });
    }
    onJump(props) {
        this.$router.push({ path: '/course-manager/termList', query: {
                id: props.id
            } });
    }
    onExport() {
        this.$confirm('是否确认导出？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let [startTime = '', endTime = ''] = this.search.dateTime || [];
            let data = {
                title: this.search.title,
                status: this.search.status,
                startTime,
                endTime,
            };
            mixin_export('/courseAdmin/camp/export', 'get', data);
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消'
            });
        });
    }
    onChangeStatus(props) {
        this.$confirm(`是否${props.status == 1 ? '停用' : '启用'}该训练营?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            let data = {
                id: props.id,
                status: props.status == 1 ? 0 : 1
            };
            try {
                const res = await changeTermStatus(data);
                if (res.data.status !== 200)
                    return this.$message.error(res.data.msg);
                this.$message({
                    type: 'success',
                    message: '更新成功'
                });
                this.getList();
            }
            catch (error) {
            }
        });
    }
};
Login = tslib_1.__decorate([
    Component
], Login);
export default Login;
